import { CSSResult } from "lit";
import { isArray, isNullable, isPlainObject, isString } from "sharekit";
function* toEntries(o) {
    for (const e of isArray(o) ? o : Object.entries(o)) {
        if (e) {
            yield e;
        }
    }
}
const isAcceptValue = (value) => !isNullable(value) && value !== false;
const combineDecl = (props) => {
    let result = "";
    for (const [key, value] of toEntries(props)) {
        if (key && isAcceptValue(value)) {
            result += `${key}:${value};`;
        }
    }
    return result;
};
const resolveStyleObject = (rules, fn) => {
    for (const [key, value] of toEntries(rules)) {
        if (value) {
            const decl = isPlainObject(value) ? combineDecl(value) : value + "";
            if (isAcceptValue(decl)) {
                fn(key ? `${key}{${decl}}` : decl);
            }
        }
    }
};
const styleObjectToStyleSheet = (rules) => {
    const sheet = new CSSStyleSheet();
    resolveStyleObject(rules, (s) => sheet.insertRule(s));
    return sheet;
};
const stringToStyleSheet = (style) => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(style);
    return sheet;
};
const toStyleSheet = (style) => {
    if (isString(style)) {
        return stringToStyleSheet(style);
    }
    if (style instanceof CSSStyleSheet) {
        return style;
    }
    if (style instanceof CSSResult) {
        return style.styleSheet;
    }
    return styleObjectToStyleSheet(style);
};
/**
 * StyleController computes and applies styles when host updated.
 */
export class StyleController {
    constructor(host, computeStyleFn, shouldRecomputeFn) {
        (this.host = host).addController(this);
        this.computeStyleFn = computeStyleFn;
        this.shouldRecomputeFn = shouldRecomputeFn;
        this.deps = [];
    }
    hostUpdated() {
        if (this.shouldRecomputeFn) {
            const newDeps = this.shouldRecomputeFn();
            if (!this.shouldRecompute(newDeps)) {
                return;
            }
        }
        const sheets = this.host.shadowRoot?.adoptedStyleSheets;
        if (!sheets) {
            return;
        }
        if (this.styleID !== undefined) {
            sheets.splice(this.styleID, 1);
        }
        const styleResult = this.computeStyleFn();
        if (!styleResult) {
            this.styleID = undefined;
            return;
        }
        this.styleID = sheets.push(toStyleSheet(styleResult)) - 1;
    }
    shouldRecompute(re) {
        if (isArray(re)) {
            if (re.length !== this.deps.length) {
                this.deps = re;
                return true;
            }
            for (let i = 0; i < this.deps.length; i++) {
                if (this.deps[i] !== re[i]) {
                    this.deps = re;
                    return true;
                }
            }
            return false;
        }
        if (re === false) {
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=style.js.map